<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import axios from "axios";
import {useRecruitmentRequestStore} from "@/stores/Request/RecruitmentRequest";

export default {
    setup() {
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();
        const {$route} = useTools();

        const recruitmentRequestStore = useRecruitmentRequestStore();

        function startSourcing() {
            loading.value = true;
            axios
                .put(`/recruitmentRequests/startSourcing/${$route.params.id}`)
                .then(response => {
                    recruitmentRequestStore.updateRecruitmentRequest(response.data);
                    getBack();
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        return {
            dialog,
            loading,
            startSourcing,
            getBack
        };
    }
};
</script>

<template>
    <v-dialog v-model="dialog" persistent scrollable max-width="600">
        <v-card>
            <w-toolbar
                color="cyan"
                :title="$t('recruitment_request.start_sourcing')"
            />
            <v-card-text>
                <v-container fluid></v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    icon="mdi-clock-start"
                    :text="$t('recruitment_request.start_sourcing')"
                    color="cyan"
                    :loading="loading"
                    @press="startSourcing"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>